import { renderToolbarGroup_unstable } from '@fluentui/react-toolbar';

/**
 * Renders the final JSX of the ToolbarRadioGroup component, given the state.
 */
export const renderToolbarRadioGroup = renderToolbarGroup_unstable;
